import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initTelegram } from "./telegram/webapp";
import { applyDocumentLang, getLang } from "./i18n/lang";
import "./styles/base.css";

// Before React: ready()/expand(), the theme attribute and the document
// direction must all be set so the first paint is already the right size, the
// right palette and the right way round.
initTelegram();
applyDocumentLang(getLang());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
